module.exports = __webpack_public_path__ + "img/banner-xwzx.12a0e3c7.png";